
// @ts-nocheck
import { defineComponent } from 'vue'
import ArtistCard from '~/components/new/blocks/ArtistCard.vue'
import Location from '~/components/icons/Location.vue'

import Telegram from '~/components/icons/Telegram.vue'
import VK from '~/components/icons/VK.vue'
import InfoDropdowns from '~/components/new/artist/InfoDropdowns.vue'
import CatalogBase from '~/components/new/blocks/CatalogBase.vue'
import PaintingCard from '~/components/new/blocks/PaintingCard.vue'
import CarouselComp from '~/components/new/ui/CarouselComp.vue'
import { useBreadcrumbsStore } from '~/store/breadcrumbs'
import { useWindowHandlers } from '~/store/window'
import { Painting } from '~/types/dto/Painting'

export default defineComponent({
  components: {
    CatalogBase,
    InfoDropdowns,
    CarouselComp,
    PaintingCard,
    Location,
    Telegram,
    VK,
    ArtistCard
  },
  async asyncData (context) {
    try {
      const artistResponse = await context.$axios.get(
        process.env.API_ENDPOINT + '/api/artists/' + context.params.name,
        {
          cache: false
        }
      )
      const otherArtistsResponse = await context.$axios.get(
        process.env.API_ENDPOINT + '/api/artists',
        {
          cache: false
        }
      )
      const filteredOtherArtists = otherArtistsResponse.data.data
        .slice(0, 10)
        .filter(artist => artist.id !== artistResponse.data.id)

      useBreadcrumbsStore().value.setTitles([artistResponse.data.fio.ru])

      return {
        artist: artistResponse.data,
        otherArtists: filteredOtherArtists
      }
    } catch (err: any) {
      return context.error(err)
    }
  },
  fetchOnServer: false,
  data () {
    return {
      paintingsPerPage: 4,
      artistsPerView: 1,
      component: ArtistCard
    }
  },
  head () {
    return {
      title: `${this.artist?.fio?.ru} - художник: биография, выставки, картины - купить картину`,
      meta: [
        { hid: 'og:title', name: 'og:title', content: `${this.artist?.fio?.ru} - художник: биография, выставки, картины - купить картину` },
        { hid: 'og:description', name: 'og:description', content: '' },
        { hid: 'description', name: 'description', content: '' },
        { hid: 'og:url', name: 'og:url', content: process.env.API_ENDPOINT + this.$route.fullPath }
      ]
    }
  },
  computed: {
    query () {
      return this.$route.query
    },
    currentPage () {
      return +this.query.page || 1
    },

    lastPage () {
      return Math.ceil(this.filteredPaintings.length / this.paintingsPerPage)
    },

    filteredPaintings () {
      if (!this.query.title) {
        return this.artist.accepted_artworks
      }
      const result = (this.artist.accepted_artworks as Painting[]).filter(
        (painting) => {
          return painting.title.ru
            .toLowerCase()
            .includes(this.query.title.trim())
        }
      )
      // if (this.query.sort_order === 'asc' && !this.query.sort_order) {
      //   return result.sort((a, b) => b.price - a.price)
      // } else {
      //   return result.sort((a, b) => a.price - b.price)
      // }
      return result
    },

    paintings () {
      return this.filteredPaintings.slice(
        (this.currentPage - 1) * this.paintingsPerPage,
        this.currentPage * this.paintingsPerPage
      )
    },

    authorInfo () {
      const themes = this.artist.tags
        .filter(tag => tag.type === 'theme')
        .map(tag => tag.title.ru)

      const styles = this.artist.tags
        .filter(tag => tag.type === 'style')
        .map(tag => tag.title.ru)

      return {
        educations: this.artist.education,
        qualifications: this.artist.qualification,
        concept: this.artist.creative_concept.ru,
        styles,
        themes,
        exhibitions: this.artist.exhibitions,
        publications: this.artist.publications
      }
    }
  },

  watch: {
    // query (value) {
    //   console.log(value)
    // }
  },
  async mounted () {
    console.log(this.artist, 'artist')
    window.matchMedia('(max-width: 660px)').addEventListener('change', (ev) => {
      if (ev.matches) {
        this.paintingsPerPage = 4
      }
    })
    useBreadcrumbsStore().value.setTitles([this.artist.fio.ru])
    await this.$nextTick()
    useWindowHandlers().listen('resize', this.resizeHandler, true)
  },
  beforeDestroy () {
    useWindowHandlers().stopListening('resize', this.resizeHandler)
  },
  methods: {
    resizeHandler () {
      if (window.innerWidth > 990) {
        this.artistsPerView = 3
      } else if (window.innerWidth > 650) {
        this.artistsPerView = 2
      } else {
        this.artistsPerView = 1
      }

      if (window.innerWidth < 660) {
        this.paintingsPerPage = 4
      } else if (window.innerWidth < 1010) {
        this.paintingsPerPage = 8
      } else if (window.innerWidth < 1100) {
        this.paintingsPerPage = 12
      } else if (window.innerWidth < 1400) {
        this.paintingsPerPage = 8
      } else {
        this.paintingsPerPage = 12
      }
    }
  }
})
